import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-name__social" }
const _hoisted_2 = { class: "hotel-name__social-title" }
const _hoisted_3 = ["data-ga-item_id"]

import { getWebsiteName } from '@utils/environmentUtils';
import { ref, computed, onBeforeMount, onUnmounted } from 'vue';
import type { HotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import { WEB_CLIENTS_NAMES } from '@global-js/constants';
import { addEntryToFavoritePersistence, removeEntryFromFavoritePersistence } from '@/js/modules/bookmark';
import BookmarkAnalytics from '@/js/modules/analytics/BookmarkAnalytics';
import type { MergedOfferItemData } from '@/interfaces/offer';
import ShareLinkAnalytics from '@/js/modules/analytics/ShareLinkAnalytics';
import { EventBus } from '@global-js/event-bus';
import type { FavoritedHotel } from '@/interfaces/api/v1-hotel-list';
import { isFavorite as isInFavorites } from '@/js/modules/bookmark';
import { getOS } from '@utils/environmentUtils';

interface Props {
	hotel: HotelData;
	bestOffer: Partial<MergedOfferItemData>;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelFeaturesSocial',
  props: {
    hotel: {},
    bestOffer: {}
  },
  setup(__props: any) {

const props = __props;

const hotelDetails = computed(() => ({
	Hotel: props.hotel.Hotel,
	Location: props.hotel.Location,
	RatingCount: props.hotel.RatingCount,
	RatingOverallValue: props.hotel.RatingOverallValue,
}));

const isFavorite = ref(false);
const clientName = getWebsiteName();
const favoriteIconTitle = computed((): string => (isFavorite.value ? 'Hotel von Merkzettel entfernen' : 'Hotel zu Merkzettel hinzufügen'));
const favoriteIconText = computed((): string => (isFavorite.value ? 'Gemerkt' : 'Merken'));

const rating = computed((): number => {
	const { Hotel } = hotelDetails.value;
	return Number(Hotel?.Category);
});

const handleFavorite = (): void => {
	const item = BookmarkAnalytics.fromHotelFeatures(hotelDetails.value.Hotel, hotelDetails.value.Location, props.bestOffer);
	if (!isFavorite.value) {
		addEntryToFavoritePersistence(item, rating.value);
	} else {
		removeEntryFromFavoritePersistence(item);
	}
};

const handleSharing = (): void => {
	const pageTitle = document.title ? document.title : WEB_CLIENTS_NAMES.at;
	const subject = `Schau dir dieses ${clientName}-Angebot an!`;
	const queryString = window.location.search ? `${window.location.search}&` : '?';
	const url = `${window.location.origin}${window.location.pathname}${queryString}utm_source=share`;
	const shareAnalytics = ShareLinkAnalytics.createInstance(String(props.hotel.Hotel.IffCode));
	shareAnalytics.fireShareLinkDomReady();

	if (navigator.share) {
		navigator
			.share({
				title: pageTitle,
				text: subject,
				url,
			})
			.catch(function (error) {
				console.log('Error sharing', error);
			});
	} else {
		window.location.href =
			'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(pageTitle + ' \n' + url + '\n\n');
	}
};

const updateBookmark = (iffCode: number, added: boolean): void => {
	if (iffCode === hotelDetails.value.Hotel.IffCode) {
		isFavorite.value = added;
	}
};

const checkForFavorites = async (): Promise<void> => {
	isFavorite.value = await isInFavorites(hotelDetails.value.Hotel.IffCode);
};

const osInfo = getOS();

const shareIconClass = computed(() => {
	if (osInfo.isAndroid) {
		return 'fa-solid fa-share-nodes hotel-name__share-icon';
	} else if (osInfo.isiOS) {
		return 'fa-kit fa-share-ios hotel-name__share-icon';
	} else {
		return 'fa-solid fa-share-from-square hotel-name__share-icon';
	}
});

onBeforeMount((): void => {
	EventBus.$on('bookmark:favoriteChange', updateBookmark);
	EventBus.$on('bookmark:hotelsUpdated', (hotels: FavoritedHotel[]) => {
		isFavorite.value = hotels.some((h) => h.IffCode === hotelDetails.value.Hotel.IffCode);
	});

	checkForFavorites();
});

onUnmounted((): void => {
	EventBus.$off('bookmark:favoriteChange', updateBookmark);
	EventBus.$off('bookmark:hotelsUpdated');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      ref: "favoriteButton",
      class: "hotel-name__social-link",
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleFavorite()), ["prevent"]))
    }, [
      _createElementVNode("title", _hoisted_2, _toDisplayString(favoriteIconTitle.value), 1 /* TEXT */),
      _createElementVNode("i", {
        ref: "favoriteButtonIcon",
        class: _normalizeClass(["fa-solid fa-heart hotel-name__social-icon", { 'hotel-name__social-icon--active': isFavorite.value }]),
        "aria-hidden": "true"
      }, null, 2 /* CLASS */),
      _createTextVNode(" " + _toDisplayString(favoriteIconText.value), 1 /* TEXT */)
    ], 512 /* NEED_PATCH */),
    _createElementVNode("a", {
      "data-ga-event": "share",
      "data-ga-content_type": "product",
      "data-ga-item_id": hotelDetails.value.Hotel.IffCode,
      class: "hotel-name__social-link",
      href: "#",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleSharing()), ["prevent"]))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(shareIconClass.value),
        "aria-hidden": "true"
      }, null, 2 /* CLASS */),
      _cache[2] || (_cache[2] = _createTextVNode(" teilen "))
    ], 8 /* PROPS */, _hoisted_3)
  ]))
}
}

})